import { render } from "./stakingPcIndex.vue?vue&type=template&id=7950154a"
import script from "./stakingPcIndex.vue?vue&type=script&lang=js"
export * from "./stakingPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__